var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 11.3334L3.6345 9.24018C3.84117 8.89352 4.01451 8.27352 4.01451 7.86685V5.94019C4.01451 3.73352 5.80784 1.94019 8.01451 1.94019C9.19872 1.94019 10.267 2.46173 11.0011 3.28647M12.0145 5.94019V7.86685C12.0145 8.27352 12.1878 8.89352 12.3878 9.24018L13.1545 10.5135C13.5945 11.2469 13.2412 12.2002 12.4345 12.4669C10.027 13.2712 7.46026 13.4016 5.00111 12.858",
    stroke: "#668899",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49833 14.2317C2.37167 14.2317 2.245 14.1851 2.145 14.0851C1.95167 13.8917 1.95167 13.5717 2.145 13.3784L12.7117 2.81175C12.905 2.61841 13.225 2.61841 13.4183 2.81175C13.6117 3.00508 13.6117 3.32508 13.4183 3.51841L2.85167 14.0851C2.75167 14.1851 2.625 14.2317 2.49833 14.2317Z",
    fill: "#668899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24792 2.13346C9.04125 2.07346 8.82792 2.02679 8.60792 2.00012C7.96792 1.92012 7.35458 1.96679 6.78125 2.13346C6.97458 1.64012 7.45458 1.29346 8.01458 1.29346C8.57458 1.29346 9.05458 1.64012 9.24792 2.13346Z",
    stroke: "#668899",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0117 12.7068C10.0117 13.8068 9.11172 14.7068 8.01172 14.7068C7.46505 14.7068 6.95838 14.4801 6.59838 14.1201C6.23838 13.7601 6.01172 13.2535 6.01172 12.7068",
    stroke: "#668899",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledNotification);
export default __webpack_public_path__ + "static/media/disabledNotification.403139c3e99e42f4b96ad920a6514f79.svg";
export { ForwardRef as ReactComponent };